import { ApproverTypeEnum, WorkflowApproval } from "@finway-group/shared/lib/models"

import i18n from "Shared/locales/i18n"
import { EmployeeService } from "Shared/services"

export const getApproverLabelData = (approval: WorkflowApproval) => {
    if (!approval) return undefined

    const autoApprover = EmployeeService.getAutoApprover()

    if (approval.approverType === ApproverTypeEnum.SUPERIOR) return { label: i18n.t("input:workflow.superior"), user: autoApprover }
    if (approval.approverType === ApproverTypeEnum.RESPONSIBLE_USER) return { label: i18n.t("input:workflow.responsible_employee"), user: autoApprover }
    if (approval.approverType === ApproverTypeEnum.AUTO_APPROVER) return { label: i18n.t("input:workflow.auto_approver"), user: autoApprover }
    if (approval.approverType === ApproverTypeEnum.REQUESTER) return { label: i18n.t("input:workflow.requester"), user: autoApprover }
    if (approval.approverType === ApproverTypeEnum.USER) {
        const approverObject = EmployeeService.getEmployeeById(approval.workflowApprover)
        return { label: `${approverObject?.firstName} ${approverObject?.lastName}`, user: approverObject }
    }
    return undefined
}
